import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { goBackFromPackagePage } from "../../../../../../../../../custom_utilities/dashboardBannerNavigation";
import images from "../../../../../../../../../utilities/images/images";
import backIcon from "../../../../../../../../../utilities/images/package_course_header/icon-back.svg";
import supportIcon from "../../../../../../../../../utilities/images/package_course_header/icon-support.svg";
import shareIcon from "../../../../../../../../../utilities/images/package_course_header/icon-share.svg";
import "./StorePackageHeader.scss";

const contactNumber = (packageData, key) =>
  packageData?.[key] || packageData?.PackageInstallmentDetails?.[key] || "";

const shareCourse = async (packageData) => {
  const share = packageData?.share || {};
  const url = share.deeplink || window.location.href;
  const text = share.message || share.course_name || "";
  if (navigator.share) {
    try {
      await navigator.share({ title: share.course_name || "Course Details", text, url });
      return;
    } catch (error) {
      if (error?.name === "AbortError") return;
    }
  }
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text ? `${text}\n${url}` : url);
      return;
    } catch (error) {
      // fall through to opening the link
    }
  }
  window.open(url, "_blank", "noopener,noreferrer");
};

const StorePackageHeader = ({ packageData }) => {
  const history = useHistory();
  const location = useLocation();
  const supportRef = useRef(null);
  const [supportOpen, setSupportOpen] = useState(false);
  const whatsapp = contactNumber(packageData, "motion_whatsapp_no");
  const phone = contactNumber(packageData, "motion_mobile_no");

  useEffect(() => {
    if (!supportOpen) return undefined;
    const close = (event) => {
      if (!supportRef.current?.contains(event.target)) setSupportOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [supportOpen]);

  const goBack = (event) => {
    event?.preventDefault?.();
    goBackFromPackagePage(history, location);
  };

  const openWhatsApp = () => {
    if (!whatsapp) return;
    window.open(
      `https://api.whatsapp.com/send?phone=${parseInt(whatsapp, 10)}`,
      "_blank",
      "noopener,noreferrer"
    );
    setSupportOpen(false);
  };

  return (
    <header className="store-package-header">
      <button type="button" className="store-package-header__back" onClick={goBack} aria-label="Back">
        <img src={backIcon} alt="" />
      </button>
      <h1 className="store-package-header__title">Course Details</h1>
      <div className="store-package-header__actions">
        <div className="store-package-header__support" ref={supportRef}>
          <button
            type="button"
            className="store-package-header__icon"
            aria-label="Support"
            aria-expanded={supportOpen}
            onClick={() => setSupportOpen((open) => !open)}
          >
            <img src={supportIcon} alt="" />
          </button>
          {supportOpen ? (
            <div className="store-package-header__support-menu" role="menu">
              <button type="button" className="store-package-header__contact" aria-label="WhatsApp" onClick={openWhatsApp}>
                <img src={images.whatsaap} alt="" />
              </button>
              <a className="store-package-header__contact" href={`tel:${phone}`} aria-label="Call" onClick={() => setSupportOpen(false)}>
                <img src={images.phoneCall} alt="" />
              </a>
            </div>
          ) : null}
        </div>
        <button
          type="button"
          className="store-package-header__icon"
          aria-label="Share"
          onClick={() => shareCourse(packageData)}
        >
          <img src={shareIcon} alt="" />
        </button>
      </div>
    </header>
  );
};

export default StorePackageHeader;
